module.exports = __webpack_public_path__ + "static/img/COC2021-7.6d66223.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-7.jpg
// module id = UpHh
// module chunks = 0